import { render, staticRenderFns } from "./OrderListing.vue?vue&type=template&id=a244d0f8&scoped=true&"
import script from "./OrderListing.vue?vue&type=script&lang=js&"
export * from "./OrderListing.vue?vue&type=script&lang=js&"
import style0 from "./OrderListing.vue?vue&type=style&index=0&id=a244d0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a244d0f8",
  null
  
)

export default component.exports